import type { DateRange } from '../types/voip';

export interface RangeOption {
  value: DateRange;
  label: string;
}

export const rangeOptions: RangeOption[] = [
  { value: 'today', label: 'Today' },
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
];

export const scopeLabels: Record<DateRange, string> = {
  today: 'today',
  '7d': 'last 7 days',
  '30d': 'last 30 days',
};

export const previousLabels: Record<DateRange, string> = {
  today: 'yesterday',
  '7d': 'previous 7 days',
  '30d': 'previous 30 days',
};

export const periodPhrases: Record<DateRange, string> = {
  today: 'today',
  '7d': 'this week',
  '30d': 'this month',
};

export const chartTitles: Record<DateRange, string> = {
  today: 'Calls by hour',
  '7d': 'Calls per day',
  '30d': 'Calls per day',
};

export function blandChartTitle(range: DateRange): string {
  return `Transfers & opportunities ${range === 'today' ? 'by hour' : 'per day'}`;
}
